import React, { useRef, useEffect } from "react";
import { NewTableAdv, TableAdv } from "..";

const defaultColumns = [
  {
    key: "clientName",
    label: "Client Name",
  },
  { key: "1-30", label: "1-30" },
  { key: "30-60", label: "30-60" },
  {
    key: "60-90",
    label: "60-90",
  },
];

const defaultRows = Array.from({ length: 10 }, (_, i) => ({
  clientName: `IBM`,
  "1-30": `1040${i + 1}`,
  "30-60": `0`,
  "60-90": `10400`,
}));

const TableChart = ({
  columns = defaultColumns,
  rows = defaultRows,
  showSlNo = false,
  serverPagination,
  defaultSelectedRows,
  onSelectionChange,
  page,
  limit,
  accordion,
  expandedRows = {},
  onRowToggle,
  totalCount,
  showCheckbox = false,
  hideToolBar = true,
  onPageChange,
  onLimitChange,
  toolbarRight = {
    search: false,
    filter: false,
    download: false,
    add: [],
  },
  noImage,
  idKey = "id",
  hideIdColumn = true,
  hiddenFields = [],
}) => {
  const fieldsToHide = hideIdColumn ? [idKey, ...hiddenFields] : hiddenFields;
  const displayColumns = columns.filter(
    (col) => !fieldsToHide.includes(col.key),
  );

  const handleSelectionChange = (selectedIndices) => {
    if (!onSelectionChange) return;
    onSelectionChange(selectedIndices);
  };

  return (
    <div className="flex-1 overflow-hidden flex flex-col">
      <TableAdv
        columns={displayColumns}
        rows={rows}
        hideToolBar={hideToolBar}
        showSlNo={showSlNo}
        showCheckbox={showCheckbox}
        toolbarRight={toolbarRight}
        noImage={noImage}
        serverPagination={serverPagination}
        defaultSelectedRows={defaultSelectedRows}
        onSelectionChange={handleSelectionChange}
        onPaginationChange={onPageChange}
        onLimitChange={onLimitChange}
        accordion={accordion}
        expandedRows={expandedRows}
        onRowToggle={onRowToggle}
        totalCount={totalCount}
        page={page}
        limit={limit}
        totalCellStyle="bg-primary text-start text-white font-semibold"
        totalText="Total"
      />
    </div>
  );
};

export default TableChart;

// import React, { useRef, useEffect } from "react";
// import { NewTableAdv } from "..";

// const defaultColumns = [
//   {
//     key: "clientName",
//     label: "Client Name",
//   },
//   { key: "1-30", label: "1-30" },
//   { key: "30-60", label: "30-60" },
//   {
//     key: "60-90",
//     label: "60-90",
//   },
// ];

// const defaultRows = Array.from({ length: 10 }, (_, i) => ({
//   clientName: `IBM`,
//   "1-30": `1040${i + 1}`,
//   "30-60": `0`,
//   "60-90": `10400`,
// }));

// const TableChart = ({
//   columns = defaultColumns,
//   rows = defaultRows,
//   showSlNo = false,
//   serverPagination,
//   defaultSelectedRows,
//   onSelectionChange,
//   page,
//   limit,
//   accordion,
//   totalCount,
//   showCheckbox = false,
//   hideToolBar = true,
//   onPageChange,
//   onLimitChange,
//   toolbarRight = {
//     search: false,
//     filter: false,
//     download: false,
//     add: [],
//   },
//   noImage,
//   idKey = "id",
//   hideIdColumn = true,
//   hiddenFields = [],
// }) => {
//   const fieldsToHide = hideIdColumn ? [idKey, ...hiddenFields] : hiddenFields;
//   const displayColumns = columns.filter(
//     (col) => !fieldsToHide.includes(col.key)
//   );

//   const handleSelectionChange = (selectedIndices) => {
//     if (!onSelectionChange) return;

//     // console.log("Raw selected indices from NewTableAdv:", selectedIndices);
//     // console.log("Current rows:", rows);

//     // Convert row indices to actual UIIDs
//     // const actualIds = selectedIndices
//     //   .map((index) => {
//     //     const row = rows[index];
//     //     if (!row) {
//     //       console.warn(`No row found at index ${index}`);
//     //       return null;
//     //     }
//     //     const actualId = row[idKey];
//     //     console.log(`Index ${index} -> Row:`, row, `-> ID: ${actualId}`);
//     //     return actualId;
//     //   })
//     //   .filter((id) => id !== undefined && id !== null);

//     // // Remove duplicates
//     // const uniqueIds = [...new Set(actualIds)];

//     // console.log("Final unique IDs to return:", uniqueIds);
//     onSelectionChange(selectedIndices);
//   };

//   return (
//     <div className={`flex-1 overflow-auto`}>
//       <NewTableAdv
//         columns={displayColumns}
//         rows={rows}
//         hideToolBar={hideToolBar}
//         showSlNo={showSlNo}
//         showCheckbox={showCheckbox}
//         toolbarRight={toolbarRight}
//         noImage={noImage}
//         serverPagination={serverPagination}
//         onSelectionChange={handleSelectionChange}
//         onPageChange={onPageChange}
//         onLimitChange={onLimitChange}
//         accrodian={accordion}
//         totalCount={totalCount}
//         page={page}
//         limit={limit}
//         totalCellStyle="bg-primary text-start text-white font-semibold"
//         totalText="Total"
//       />
//     </div>
//   );
// };

// export default TableChart;
